import React from "react";

const CookieConsent = ({ onAccept }) => {
  return (
    <div className="fixed bottom-4 left-4 bg-white shadow-xl p-4 z-50 max-w-sm w-full rounded-lg border border-gray-200">
      <p className="text-sm text-gray-700 mb-3">
        We use cookies to enhance your experience. By continuing to visit this site, you agree to our use of cookies.
      </p>
      <div className="flex justify-end">
        <button
          onClick={onAccept}
          className="bg-blue-600 text-white text-sm px-3 py-1.5 rounded hover:bg-blue-700 transition duration-300"
        >
          Got it!
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
